import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

type MyTimeDateHeaderTooltipTitleProps = {
  workTime: string | number;
  overtime: string | number;
  voluntaryOvertime: string | number;
  date: string | number | Date;
};

export const MyTimeDateHeaderTooltipTitle = ({
  workTime,
  overtime,
  voluntaryOvertime,
  date,
}: MyTimeDateHeaderTooltipTitleProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const whiteColor = theme.palette.white.main;
  const localizedDate = new Date(date).toLocaleDateString();

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box height="8px" />
      <Typography variant="caption" color={whiteColor}>
        {localizedDate}
      </Typography>
      <Box height="8px" />
      <Typography variant="caption" color={whiteColor}>
        {t("MY_TIME_WORKING_TIME")}: {workTime}
      </Typography>
      <Typography variant="caption" color={whiteColor}>
        {t("MY_TIME_OVERTIME")}: {overtime}
      </Typography>
      <Typography variant="caption" color={whiteColor}>
        {t("MY_TIME_VOLUNTARY_OVERTIME")}: {voluntaryOvertime}
      </Typography>
      <Box height="8px" />
    </Box>
  );
};

export default MyTimeDateHeaderTooltipTitle;
